export const FetchHeader = (contentFile: boolean = false): Record<string, string> => {
       const userInfo = useCookie('UserInfo').value as any;

       // if (!userInfo || !userInfo.tokens || !userInfo.tokens.accessToken) {
       //        throw new Error('Access token is missing');
       // }

       return {
              'Authorization': `Bearer ${userInfo.tokens.accessToken}`,
       };
};
//               'Content-Type': contentFile ? 'multipart/form-data; boundary=----WebKitFormBoundaryyEmKNDsBKjB7QEqu' : 'application/json'
